import requests from "./httpService";

const ViewTradingServices = {

    // Scanner signals (ViewTrading)
    getViewTrading: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return requests.get(`/view-trading${query ? `?${query}` : ''}`);
    },
    getTodayViewTrading: async (date) => {
        return requests.get(`/view-trading/today${date ? `?date=${date}` : ''}`);
    },
    getViewTradingById: async (id) => {
        return requests.get(`/view-trading/${id}`);
    },
    deleteViewTrading: async (id) => {
        return requests.delete(`/view-trading/${id}`);
    },

    // Scanner webhooks
    getAllWebhooks: async () => {
        return requests.get(`/scanner-webhooks`);
    },
    getWebhookById: async (id) => {
        return requests.get(`/scanner-webhooks/${id}`);
    },
    createWebhook: async (data) => {
        return requests.post(`/scanner-webhooks`, data);
    },
    updateWebhooks: async (id, data) => {
        return requests.put(`/scanner-webhooks/${id}`, data);
    },
    deleteWebhook: async (id) => {
        return requests.delete(`/scanner-webhooks/${id}`);
    },
}

export default ViewTradingServices;
